<script setup>
import { store } from "./store.vue";
import CustomSelect from "./CustomSelect.vue";
/** Komponente zur Anzeige der Krankenkassen-Daten des Benutzers ohne Änderungsmöglichkeit
 * @displayName Anzeige Krankenkasse
 */
</script>
<script>
export default {
  name: "DataKKTab",

  data() {
    return {
      openIndex: null,
      store,


    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
  },

  beforeCreate: function () {

    /*
        if (action % 2 == 1) {
          // olddraft wurde initialisiert
          let olddraft = store.masterData.olddraft.sService.Entwuerfe.AenderungKrankenkasse;
    
    
    
          //olddraft.KRANKENKASSE = "-1";
          olddraft.KRANKENKASSE = _sKKData.KKNR;
    
          if (_kinderData) {
            olddraft.KILO = "1";
            _kinderData?.KLFDNR.forEach(kind => {
              olddraft.KINDER.push(
                {
                  VORNAME: kind.KVORNAME,
                  NAME: kind.KNAME,
                  GEBDAT: kind.KGEBDAT,
                  uploads: [], //füllen, da der Service ansonsten nicht angenommen wird
                  uploadFolgt: "1",
                  vonPensus: true,
                  uuid: this.$servertalk.getUUID(),
                }
    
              )
            })
          }
    
          olddraft.BEITRAGSPFLICHTIG = _sKKData.KKSTATUS; // Dropdown (eigenes)
    
    
          olddraft.uuid = this.$servertalk.getUUID();
        }
        if (action >= 2) {
          // draft wurde initialisiert
          this.$servertalk.copyToDraftSelfService("AenderungKrankenkasse");
        }
        */
  },


  computed: {
    sKKData() {
      let _versorgung = false;


      //es kann auch keine KK geben

      if (typeof store.masterData.data.Versorgung === "object") {
        if (store.masterData.data.Versorgung.PMNR.length > 1) {
          _versorgung = store.masterData.data.Versorgung.PMNR[0]
        }

        else {
          _versorgung = store.masterData.data.Versorgung.PMNR
        }
      }


      return _versorgung?.Krankenkasse ?? false;
    },

    sKrankenkasseOptions() {
      let opts = this.$servertalk.getSelectOpts("KRANKENKASSE");
      //finde die private Kasse
      let privNr = opts.findIndex(el => el.value == '999');

      if ((this.sKKData.KKSTATUS == '-1') || (this.sKKData.KKSTATUS == '')) {
        opts = [{ text: "unbekannt", value: "-1" }].concat(opts);
      }
      if (this.sKKData.KKSTATUS != '2') {
        //opts = opts.slice(0, privNr - 1).concat(opts.slice(privNr + 1));
        opts = opts.slice(0, privNr).concat(opts.slice(privNr + 1)); // Korrektur von Kevin, Mail 12.02.26
      }
      if (this.sKKData.KKSTATUS == '2') {
        opts = [opts[privNr]];
      }
      return opts;
    },

    sBeitragspflichtOptions() {
      let opts = this.$servertalk.getSelectOpts("KK_STATUS");

      if ((this.sKKData.KKSTATUS == '-1') || (this.sKKData.KKSTATUS == '')) {
        opts = [{ text: "unbekannt", value: "-1" }].concat(opts);
      }
      return opts;
    },
    isKKChangeAllowed() {
      return this.$servertalk.isSelfserviceAllowed("AenderungKrankenkasse");
    },
  },
  methods: {
    toggleAccordion(index) {
      if (this.isOpen(index)) {
        this.openIndex = null;
      } else {
        this.openIndex = index;
      }
    },
    isOpen(index) {
      return this.openIndex === index;
    },

  },
};
</script>

<template>
  <form>
    <div class="grid xl:grid-cols-2 gap-5">
      <div>
        <label for="aendKrankenkasseAb" class="text-sm mb-2 block schwebend">
          Versichert seit
        </label>
        <div class="schwebend"><input type="date" v-model="sKKData.KKDATAB" disabled
            class="w-full p-3 border border-secondary/50 rounded-md mb-8 ">
        </div>
      </div>
    </div>

    <div class="grid xl:grid-cols-2 sm:gap-5">

      <div>
        <CustomSelect class="select schwebend" :keyEmpty="-1" label="Beitragspflicht" :options="sBeitragspflichtOptions"
          :default="sKKData.KKSTATUS" disabled="true" />
      </div>
      <div>
        <CustomSelect @input="setKrankenkasse" class="select" label="Krankenkasse" disabled
          :options="sKrankenkasseOptions" :keyEmpty="'-1'" :default="sKKData.KKNR" :tabindex="15" />
      </div>
    </div>

    <router-link to="/sservice-antrag-aenderungkrankenkasse" custom v-slot="{ navigate }">
      <button @click="navigate" :disabled="store.masterData.isReadOnly || !isKKChangeAllowed" role="link" type="submit"
        class="bg-primary text-white py-4 w-72 rounded-md text-lg lg:text-xl mx-auto block hover:bg-tertiary transition disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary">
        Krankenkassendaten ändern
      </button>
    </router-link>

  </form>
</template>
